import { SERVICES } from "@/lib/site";
import {
  PaintBucket, Hammer, Square, Layers, PanelTop, DoorOpen, Building2, Wrench, HardHat, ArrowUpRight,
} from "lucide-react";

const ICONS = { PaintBucket, Hammer, Square, Layers, PanelTop, DoorOpen, Building2, Wrench, HardHat };

export default function Services() {
  return (
    <section id="services" data-testid="services-section" className="relative bg-bone py-20 md:py-32">
      <div className="px-5 sm:px-6 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-end mb-12 md:mb-16">
          <div className="lg:col-span-5">
            <div className="text-[11px] sm:text-xs font-bold uppercase tracking-[0.25em] sm:tracking-[0.3em] text-sunrise">— What we do</div>
            <h2 className="mt-3 sm:mt-4 font-display font-black text-navy tracking-tight text-[34px] sm:text-5xl lg:text-6xl leading-[1.04]">
              Nine trades. <br />One accountable crew.
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="text-muted-foreground text-base lg:text-lg leading-relaxed">
              We self-perform the majority of our work so projects stay on schedule and on spec. Whether you need a single
              specialty trade or a full general contractor, we run a tight, communicative crew with clean job sites and
              clear pricing.
            </p>
          </div>
        </div>

        {/* Tetris grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Hammer;
            const tall = i === 0 || i === 5;
            const wide = i === 2;
            return (
              <a
                key={s.key}
                href="#contact"
                data-testid={`service-card-${s.key}`}
                className={`group relative bg-white border border-border rounded-2xl p-6 sm:p-8 lg:p-10 flex flex-col justify-between min-h-[220px] sm:min-h-[260px] hover:bg-navy hover:text-white hover:border-navy elev-1 hover:elev-3 transition-all duration-300 ${
                  tall ? "lg:row-span-2 lg:min-h-[540px]" : ""
                } ${wide ? "lg:col-span-2" : ""}`}
              >
                <div className="flex items-start justify-between">
                  <div className="w-12 h-12 sm:w-14 sm:h-14 grid place-items-center bg-secondary group-hover:bg-sunrise/15 rounded-xl text-navy group-hover:text-sunrise transition-colors">
                    <Icon className="w-5 h-5 sm:w-6 sm:h-6" />
                  </div>
                  <span className="num-label text-sm text-muted-foreground group-hover:text-white/40">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="mt-6 sm:mt-10">
                  <h3 className="font-display font-bold text-xl sm:text-2xl lg:text-3xl tracking-tight">{s.name}</h3>
                  <p className="mt-2 sm:mt-3 text-sm leading-relaxed text-muted-foreground group-hover:text-white/70">
                    {s.blurb}
                  </p>
                  <div className="mt-4 sm:mt-6 flex items-center gap-2 text-[11px] sm:text-xs font-bold uppercase tracking-[0.18em] sm:tracking-[0.2em] text-sunrise">
                    Get a quote <ArrowUpRight className="w-3.5 h-3.5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                  </div>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
